// ----------------------------------------------------------------------

export const svgColorClasses = { root: 'antl__svg__color__root' };
